import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-solution',
  templateUrl: './dialog-solution.component.html',
  styleUrls: ['./dialog-solution.component.scss']
})
export class DialogSolutionComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogSolutionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.data.displayName && this.data.displayName.trim()) {
      this.dialogRef.close(this.data);
    }
  }

  @HostListener('keydown.enter', ['$event'])
  onEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    this.onSubmit();
  }
}
